import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  Companion_getInstance3bjjjd8igr9ok as Companion_getInstance,
  beginUse146s8dwmfk72s as beginUse,
  Listenable3m4zqvjcbvczy as Listenable,
  Reactive1jy75v4li6ldv as Reactive,
  get_state389x218zizu8a as get_state,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
} from './coreInterfaces.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance_0,
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  ReactiveStatel8ixobo86msn as ReactiveState,
} from './ReactiveState.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BaseListenableClass;
function BaseListenable() {
  if (BaseListenableClass === VOID) {
    class $ {
      static new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$($box) {
        var $this = createThis(this, $box);
        $this.listeners_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        return $this;
      }
      activate_yijg9v_k$() {
      }
      deactivate_pmdz1g_k$() {
      }
      addListener_6y9mct_k$(listener) {
        if (this.listeners_1.isEmpty_y1axqb_k$()) {
          this.activate_yijg9v_k$();
        }
        this.listeners_1.add_utx5q5_k$(listener);
        return () => {
          var tmp0 = this.listeners_1;
          var tmp$ret$0;
          $l$block: {
            // Inline function 'kotlin.collections.indexOfFirst' call
            var index = 0;
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var item = _iterator__ex2g4s.next_20eer_k$();
              if (item === listener) {
                tmp$ret$0 = index;
                break $l$block;
              }
              index = index + 1 | 0;
            }
            tmp$ret$0 = -1;
          }
          var pos = tmp$ret$0;
          var tmp;
          if (!(pos === -1)) {
            this.listeners_1.removeAt_6niowx_k$(pos);
            var tmp_0;
            if (this.listeners_1.isEmpty_y1axqb_k$()) {
              this.deactivate_pmdz1g_k$();
              tmp_0 = Unit_instance;
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        };
      }
      invokeAllListeners_uusj2y_k$() {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = toList(this.listeners_1).iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          $l$block: {
            try {
              element();
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                if (e instanceof CancellationException()) {
                  break $l$block;
                }
                Companion_getInstance().reportException_1(e);
              } else {
                throw $p;
              }
            }
          }
        }
      }
    }
    protoOf($).beginUse_omrbby_k$ = beginUse;
    initMetadataForClass($, 'BaseListenable', VOID, VOID, [Listenable()]);
    BaseListenableClass = $;
  }
  return BaseListenableClass;
}
var BaseReactiveClass;
function BaseReactive() {
  if (BaseReactiveClass === VOID) {
    class $ extends BaseListenable() {
      static new_com_lightningkite_reactive_core_BaseReactive_2kvjp3_k$(start, $box) {
        start = start === VOID ? Companion_getInstance_0().notReady_1 : start;
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$($box);
        $this.state_1 = start;
        return $this;
      }
      set_state_wnfcx0_k$(value) {
        if (!(_ReactiveState___get_raw__impl__92ipya(this.state_1) === _ReactiveState___get_raw__impl__92ipya(value)) && !equals(new (ReactiveState())(this.state_1), new (ReactiveState())(value))) {
          this.state_1 = value;
          this.invokeAllListeners_uusj2y_k$();
        }
      }
      get_state_wc71uu_k$() {
        return this.state_1;
      }
    }
    initMetadataForClass($, 'BaseReactive', VOID, VOID, [Reactive()]);
    BaseReactiveClass = $;
  }
  return BaseReactiveClass;
}
var BaseReactiveValueClass;
function BaseReactiveValue() {
  if (BaseReactiveValueClass === VOID) {
    class $ extends BaseListenable() {
      static new_com_lightningkite_reactive_core_BaseReactiveValue_bwum4c_k$(start, $box) {
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$($box);
        $this.value_1 = start;
        return $this;
      }
      set_value_v1vabv_k$(value) {
        if (!(this.value_1 === value) && !equals(this.value_1, value)) {
          this.value_1 = value;
          this.invokeAllListeners_uusj2y_k$();
        }
      }
      get_value_j01efc_k$() {
        return this.value_1;
      }
    }
    protoOf($).get_state_wc71uu_k$ = get_state;
    initMetadataForClass($, 'BaseReactiveValue', VOID, VOID, [ReactiveValue()]);
    BaseReactiveValueClass = $;
  }
  return BaseReactiveValueClass;
}
//region block: exports
export {
  BaseListenable as BaseListenable1u3g4s45l82o6,
  BaseReactiveValue as BaseReactiveValue1ggyqczzm31cy,
  BaseReactive as BaseReactive302n39o7i5yop,
};
//endregion

//# sourceMappingURL=abstracts.mjs.map
